import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useAuth } from './AuthProvider'

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #1a1a1a;
  color: white;
`

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #ff4444;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 1rem;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`

const LoginCallback: React.FC = () => {
  const { oktaAuth } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('LoginCallback: Starting callback processing...')
        await oktaAuth.handleLoginRedirect()
        console.log('LoginCallback: Callback processed successfully, navigating to /')
        navigate('/')
      } catch (error) {
        console.error('Login callback error:', error)
        navigate('/auth/error')
      }
    }

    handleCallback()
  }, [oktaAuth, navigate])

  return (
    <LoadingContainer>
      <LoadingSpinner />
      <div>Processing login...</div>
    </LoadingContainer>
  )
}

export default LoginCallback